module.exports = __webpack_public_path__ + "img/twobottomlv.ff843c70.svg";